/* eslint-disable no-console */
import React, { ReactNode } from 'react';
import { ErrorBoundary } from '@restworld/utils-common';

import { Heading } from '@restworld/ui-ds-base';

interface ErrorBoundaryProps {
  children: ReactNode;
}
export const ErrorBoundaryWrapper: React.FC<ErrorBoundaryProps> = ({ children }) => {
  return (
    <ErrorBoundary
      onError={(error, componentStack) => {
        // The boundary already reports the error to OpenObserve RUM; this is just local logging.
        console.trace(error, 'page error');
        console.trace(componentStack, 'page error componentStack');
      }}
      fallback={
        <div className="fixed top-[50%] left-[50%] -mt-[150px] -ml-[300px] max-w-2xl min-w-104 p-8">
          <Heading size={1} weight="bold">
            Ooops! È appena avvenuto qualcosa di inaspettato ;( Se il problema persiste, scrivi all&apos;assistenza
          </Heading>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
export default ErrorBoundaryWrapper;
